/* eslint-disable react/jsx-curly-newline */
import { FormattedMessage } from 'react-intl';
import { CheckoutTestResult } from 'components/ui/organisms/monarch/rules/checkout/types';
import { MonarchDataConsumer } from 'helpers/eventing/monarch/MonarchDataConsumer';
import { centsToDollarString } from 'helpers/priceHelpers';
import { CouponForm } from './coupon-form';
import { OrderSummaryProps } from './types';
import './order-summary.scss';

export const OrderSummary = ({
  priceDetails,
  onApplyCoupon,
  onRemoveCoupon,
}: OrderSummaryProps) => {
  const { lineItemsTotalPrice, cartTotal, fractionDigits, cartDiscount } =
    priceDetails;

  const lineItemsPriceInDollars = centsToDollarString(
    lineItemsTotalPrice,
    fractionDigits,
  );

  const totalAmountInDollars = centsToDollarString(cartTotal, fractionDigits);

  const discountAmountInDollars = centsToDollarString(
    cartDiscount?.amount,
    fractionDigits,
  );

  const hasDiscountCode = !!cartDiscount?.discount?.code;

  return (
    <div className="order-summary" style={{ width: '100%' }}>
      <div className="summary-details">
        <h2 className="h4 mb-3" style={{ fontWeight: 700 }}>
          <MonarchDataConsumer<CheckoutTestResult> experimentKey="checkout">
            {(monarchData) =>
              monarchData?.data?.couponTitleText ?? (
                <FormattedMessage
                  id="payment.summary.heading"
                  defaultMessage="Summary"
                  description="Order Summary Heading for financial details"
                />
              )
            }
          </MonarchDataConsumer>
        </h2>
        <div className="price-row d-flex justify-content-between mb-3">
          <span>Price</span>
          <span className="h4 mb-0 price-value">{lineItemsPriceInDollars}</span>
        </div>

        {(cartDiscount?.amount ?? 0) > 0 && (
          <div className="d-flex justify-content-between mb-3">
            <span>Discounts applied</span>
            <span>-{discountAmountInDollars}</span>
          </div>
        )}

        <CouponForm
          cartDiscount={cartDiscount}
          hasDiscount={hasDiscountCode}
          onApplyCoupon={onApplyCoupon}
          onRemoveCoupon={onRemoveCoupon}
        />

        <div className="d-flex justify-content-between mt-4 pt-3">
          <h2 className="h4 mb-0 total-label">Total</h2>
          <span className="h4 mb-0 total-value">{totalAmountInDollars}</span>
        </div>
      </div>
    </div>
  );
};
